import { jsx as i } from "react/jsx-runtime";
import { memo as w, useMemo as b, useCallback as x } from "react";
import n from "./MetricSelectorSelect.js";
import { getIndexFromID as p, withSortableElement as q } from "@biron-data/react-components";
import y from "./MetricSelectorCascader.js";
import { useLanguageResolver as I } from "@biron-data/react-contexts";
const S = w(function({
  id: o,
  value: e,
  defaultView: g,
  canRemove: m,
  onChange: r,
  onDelete: c,
  groupMetricsByView: h,
  viewsWithMetrics: l,
  unavailableViews: M,
  getPopupContainer: s
}) {
  const v = I(), t = b(() => e ? {
    ...e,
    growth: e.growth ? {
      ...e.growth,
      period: {
        ...e.growth.period,
        quantity: e.growth.period.quantity
      }
    } : void 0
  } : void 0, [e]), f = x(
    (d) => {
      d ? r == null || r(p(o), {
        ...t || {},
        ...d
      }) : c && c(p(o));
    },
    [t, r, o, c]
  ), u = `${v.get("configuration-add-metric")} ...`;
  return h ? /* @__PURE__ */ i(y, { value: t, defaultView: g, placeholder: u, canRemove: m, onChange: f, viewsWithMetrics: l, unavailableViews: M, getPopupContainer: s }) : /* @__PURE__ */ i(n, { value: t, placeholder: u, canRemove: m, onChange: f, viewsWithMetrics: l, getPopupContainer: s });
});
S.Sortable = q(S);
export {
  S as default
};
//# sourceMappingURL=SingleMetricSelector.js.map
